module.exports = __webpack_public_path__ + "static/media/image-576.2d4d756a.webp";